'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { FeedbackContainer, StyledAction } from './elements';
import { CheckedValue, FeedbackVariant } from './types';
import { Icon } from '../Icon';
const getIcon = (variant, value) => {
  const src = {
    'like-positive': 'vote-thumbs-up',
    'like-negative': 'vote-thumbs-down',
    'check-positive': 'checkmark-v',
    'check-negative': 'close-x'
  }[`${variant}-${value}`];
  const title = {
    'like-positive': 'thumbs-up',
    'like-negative': 'thumbs-down',
    'check-positive': 'checkmark',
    'check-negative': 'close-x'
  }[`${variant}-${value}`];
  return /*#__PURE__*/React.createElement(Icon.SSR, {
    src: src,
    title: title
  });
};
export const Feedback = ({
  variant = FeedbackVariant.LIKE,
  ariaLabel,
  value = '',
  onClick,
  ...props
}) => /*#__PURE__*/React.createElement(FeedbackContainer, _extends({
  "aria-label": ariaLabel,
  "data-aui": "feedback",
  onClick: onClick
}, props), /*#__PURE__*/React.createElement(StyledAction, {
  $checked: value === CheckedValue.POSITIVE,
  "aria-pressed": value === CheckedValue.POSITIVE,
  value: CheckedValue.POSITIVE,
  variant: "outline"
}, getIcon(variant, CheckedValue.POSITIVE)), /*#__PURE__*/React.createElement(StyledAction, {
  $checked: value === CheckedValue.NEGATIVE,
  "aria-pressed": value === CheckedValue.NEGATIVE,
  value: CheckedValue.NEGATIVE,
  variant: "outline"
}, getIcon(variant, CheckedValue.NEGATIVE)));